export const selectLocale = state => state.common.locale

